import { api } from '@api'
import { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'

export type Category = {
  id: string
  avatarUrl: string | null
  name: string
  contactAccountIds?: string[]
}

const fetchCategories = async ({ pageParam = '0', q }: FetchParams): Promise<PaginatedResponse<Category>> => {
  const url = q
    ? `/categories?q=${q}` + `&page=${pageParam}`
    : `/categories?page=${pageParam}`
    const { data } = await api.get<PaginatedResponse<Category>>(url)
  return data
}

export const usePaginateCategories = (q?: string) => {
  return usePaginate<Category>('categories', fetchCategories, {q})
}
